import AxiosClient from "../AxiosClient";

export const getListOrderDetail = (params) => {
  const url = "/api/orderDetail/searchInfoList";
  return AxiosClient.post(url, params);
};

export const insertOrder = (params) => {
  const url = "/api/order/insertInfo";
  return AxiosClient.post(url, params);
};
